import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { getLegacyClerkDomainRedirect } from "./lib/legacy-clerk-domain-redirect";
import { getBrandedCustomerPortalRedirect } from "./lib/branded-customer-portal";
import { portfolioAppUrl, shouldRedirectLegacyPortfolio } from "./lib/app-surface";
import { seedNavigationStart } from "./lib/app-performance";

// Must run before React/module boot work to measure real usable-content time.
seedNavigationStart();

const releaseMeta = document.querySelector<HTMLMetaElement>(
  'meta[name="portfolio-release-id"]',
);
const releaseId =
  releaseMeta?.content &&
  releaseMeta.content !== "__PORTFOLIO_RELEASE_ID__"
    ? releaseMeta.content
    : import.meta.env.VITE_PORTFOLIO_RELEASE_ID?.trim() || "local";
document.documentElement.dataset.portfolioReleaseId = releaseId;

const legacyDomainRedirect = getLegacyClerkDomainRedirect(window.location);
const brandedCustomerPortalRedirect = getBrandedCustomerPortalRedirect(window.location);
const legacyPortfolioRedirect = shouldRedirectLegacyPortfolio(window.location)
  ? portfolioAppUrl(window.location)
  : null;

if (brandedCustomerPortalRedirect || legacyDomainRedirect || legacyPortfolioRedirect) {
  // External Clerk's production cookies are first-party only on the supported
  // metalui.co.uk root. Replace avoids trapping Back on an unsupported host.
  window.location.replace(
    brandedCustomerPortalRedirect ?? legacyDomainRedirect ?? legacyPortfolioRedirect!,
  );
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
